import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * primary: the one main step on a screen; secondary: an ordinary step; quiet: a step that should
   * not draw the eye. None of them carries a state colour.
   */
  variant?: "primary" | "secondary" | "quiet";
  /** Something is being sent: the button waits and cannot be pressed again. */
  busy?: boolean;
}

export function Button({ variant = "secondary", busy = false, className, type = "button", disabled, children, ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={clsx("button", `button--${variant}`, className)}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy && <span className="button__spinner" aria-hidden="true" />}
      {children}
    </button>
  );
}
